import { Component, computed, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-chevron-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      [style.color]="color()"
      [class]="iconClass()">
      <path [attr.d]="path()" />
    </svg>
  `,
})
export class ChevronIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');

  /** Controls which direction the chevron points. */
  readonly direction = input<'up' | 'down'>('down');

  readonly path = computed(() =>
    this.direction() === 'up' ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'
  );
}
